import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGoogle,
  faFacebookF,
  faYoutube,
  faGooglePlay,
  faTwitter,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";
import { faPaperPlane, faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import "./Footer.css";

const Footer = () => {
  const [expandedSections, setExpandedSections] = useState({
    features: false,
    quickLinks: false,
    contact: false
  });

  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  return (
    <footer
      className="pt-5 pb-4"
      style={{
        backgroundColor: "#278D69",
        color: "#fff",
        borderTopLeftRadius: "25px",
        borderTopRightRadius: "25px",
      }}
    >
      <div className="container">
        <div className="row mb-5">
          {/* Stay Updated Section */}
          <div className="col-lg-4 col-md-6 mb-5 mb-lg-0">
            <h5 className="mb-3 fw-bold" style={{ color: "#fff", opacity: 1 }}>
              Stay Updated
            </h5>
            <p
              className="mb-3"
              style={{ fontSize: "14px", color: "rgba(255, 255, 255, 0.9)" }}
            >
              Subscribe to our newsletter for the latest features and updates
            </p>
            <div className="subscribe-container">
              <div
                className="subscribe"
                style={{
                  height: "54px",
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  borderRadius: "54px",
                  padding: "5px",
                  overflow: "hidden",
                  backgroundColor: "rgb(255, 255, 255)",
                }}
              >
                <input
                  type="email"
                  placeholder="Enter your email"
                  style={{
                    fontFamily: "'Dosis', sans-serif",
                    border: "0",
                    flex: "1",
                    padding: "0 16px",
                    outline: "none",
                    backgroundColor: "transparent",
                    color: "#333",
                  }}
                />
                <button
                  style={{
                    border: "0",
                    height: "44px",
                    width: "44px",
                    borderRadius: "44px",
                    backgroundColor: "#00D389",
                    cursor: "pointer",
                    transition: "all .2s",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.backgroundColor = "#0fb9b1")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.backgroundColor = "#00D389")
                  }
                >
                  <FontAwesomeIcon
                    icon={faPaperPlane}
                    style={{ color: "#fefefe" }}
                  />
                </button>
              </div>
            </div>

            {/* Social Media Links - Moved to bottom left */}
            <div className="mt-5 pt-5">
              <p
                className="mb-3 fw-bold"
                style={{ fontSize: "14px", color: "rgba(255, 255, 255, 0.9)" }}
              >
                FOLLOW US
              </p>
              <div className="d-flex gap-3">
                <a
                  href="#"
                  className="text-decoration-none"
                  style={{ color: "rgba(255, 255, 255, 0.9)" }}
                >
                  <FontAwesomeIcon icon={faGoogle} />
                </a>
                <a
                  href="#"
                  className="text-decoration-none"
                  style={{ color: "rgba(255, 255, 255, 0.9)" }}
                >
                  <FontAwesomeIcon icon={faFacebookF} />
                </a>
                <a
                  href="#"
                  className="text-decoration-none"
                  style={{ color: "rgba(255, 255, 255, 0.9)" }}
                >
                  <FontAwesomeIcon icon={faYoutube} />
                </a>
                <a
                  href="#"
                  className="text-decoration-none"
                  style={{ color: "rgba(255, 255, 255, 0.9)" }}
                >
                  <FontAwesomeIcon icon={faGooglePlay} />
                </a>
                <a
                  href="#"
                  className="text-decoration-none"
                  style={{ color: "rgba(255, 255, 255, 0.9)" }}
                >
                  <FontAwesomeIcon icon={faTwitter} />
                </a>
                <a
                  href="#"
                  className="text-decoration-none"
                  style={{ color: "rgba(255, 255, 255, 0.9)" }}
                >
                  <FontAwesomeIcon icon={faInstagram} />
                </a>
              </div>
            </div>
          </div>

          {/* Features Section */}
          <div className="col-lg-3 col-md-6 mb-5 mb-lg-0 offset-lg-1">
            <div className="footer-section-header" onClick={() => toggleSection('features')}>
              <h5 className="mb-4 fw-bold" style={{ color: "#fff", opacity: 1 }}>
                Features
              </h5>
              <div className="mobile-toggle d-lg-none">
                <FontAwesomeIcon 
                  icon={expandedSections.features ? faChevronUp : faChevronDown} 
                  style={{ color: "#fff", fontSize: "14px" }}
                />
              </div>
            </div>
            <div className={`footer-section-content ${expandedSections.features ? 'expanded' : ''}`}>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <a
                    href="#"
                    className="text-decoration-none"
                    style={{ color: "rgba(255, 255, 255, 0.9)", fontSize: "14px" }}
                  >
                    Sales Management
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="#"
                    className="text-decoration-none"
                    style={{ color: "rgba(255, 255, 255, 0.9)", fontSize: "14px" }}
                  >
                    Purchase & Procurement
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="#"
                    className="text-decoration-none"
                    style={{ color: "rgba(255, 255, 255, 0.9)", fontSize: "14px" }}
                  >
                    Financial Reporting
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="#"
                    className="text-decoration-none"
                    style={{ color: "rgba(255, 255, 255, 0.9)", fontSize: "14px" }}
                  >
                    Inventory Control
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="#"
                    className="text-decoration-none"
                    style={{ color: "rgba(255, 255, 255, 0.9)", fontSize: "14px" }}
                  >
                    User & Access Management
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Quick Links Section */}
          <div className="col-lg-2 col-md-6 mb-5 mb-lg-0">
            <div className="footer-section-header" onClick={() => toggleSection('quickLinks')}>
              <h5 className="mb-4 fw-bold" style={{ color: "#fff", opacity: 1 }}>
                Quick Links
              </h5>
              <div className="mobile-toggle d-lg-none">
                <FontAwesomeIcon 
                  icon={expandedSections.quickLinks ? faChevronUp : faChevronDown} 
                  style={{ color: "#fff", fontSize: "14px" }}
                />
              </div>
            </div>
            <div className={`footer-section-content ${expandedSections.quickLinks ? 'expanded' : ''}`}>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <a
                    href="#"
                    className="text-decoration-none"
                    style={{ color: "rgba(255, 255, 255, 0.9)", fontSize: "14px" }}
                  >
                    About Us
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="#"
                    className="text-decoration-none"
                    style={{ color: "rgba(255, 255, 255, 0.9)", fontSize: "14px" }}
                  >
                    Documentation
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="#"
                    className="text-decoration-none"
                    style={{ color: "rgba(255, 255, 255, 0.9)", fontSize: "14px" }}
                  >
                    Support Center
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="#"
                    className="text-decoration-none"
                    style={{ color: "rgba(255, 255, 255, 0.9)", fontSize: "14px" }}
                  >
                    Pricing Plans
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="/privacy"
                    className="text-decoration-none"
                    style={{ color: "rgba(255, 255, 255, 0.9)", fontSize: "14px" }}
                  >
                    Privacy Policy
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="/refund"
                    className="text-decoration-none"
                    style={{ color: "rgba(255, 255, 255, 0.9)", fontSize: "14px" }}
                  >
                    Refund Policy
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="/terms"
                    className="text-decoration-none"
                    style={{ color: "rgba(255, 255, 255, 0.9)", fontSize: "14px" }}
                  >
                    Terms of Service
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Contact Section */}
          <div className="col-lg-2 col-md-6">
            <div className="footer-section-header" onClick={() => toggleSection('contact')}>
              <h5 className="mb-4 fw-bold" style={{ color: "#fff", opacity: 1 }}>
                Contact
              </h5>
              <div className="mobile-toggle d-lg-none">
                <FontAwesomeIcon 
                  icon={expandedSections.contact ? faChevronUp : faChevronDown} 
                  style={{ color: "#fff", fontSize: "14px" }}
                />
              </div>
            </div>
            <div className={`footer-section-content ${expandedSections.contact ? 'expanded' : ''}`}>
              <ul className="list-unstyled">
                <li
                  className="mb-2"
                  style={{ color: "rgba(255, 255, 255, 0.9)", fontSize: "14px" }}
                >
                  (212) 555-0100
                </li>
                <li
                  className="mb-2"
                  style={{ color: "rgba(255, 255, 255, 0.9)", fontSize: "14px" }}
                >
                  support@numra.com
                </li>
                <li
                  className="mb-4"
                  style={{ color: "rgba(255, 255, 255, 0.9)", fontSize: "14px" }}
                >
                  123 Business Center, Suite 400
                  <br />
                  New York, NY 10005
                </li>
              </ul>

              <a
                href="#"
                className="btn btn-light rounded-pill px-4 py-2"
                style={{
                  backgroundColor: "white",
                  color: "#333",
                  fontWeight: "500",
                  width: "100%",
                  transition: "all 0.3s ease",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = "#f0f0f0";
                  e.currentTarget.style.transform = "translateY(-2px)";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = "white";
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                Schedule Demo
              </a>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        /* Mobile-specific styles */
        @media (max-width: 767.98px) {
          .footer-section-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            cursor: pointer;
            padding: 10px 0;
            border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          }

          .footer-section-header:hover {
            background-color: rgba(255, 255, 255, 0.05);
            border-radius: 8px;
            padding: 10px 15px;
            margin: 0 -15px;
          }

          .mobile-toggle {
            display: block !important;
            transition: transform 0.3s ease;
          }

          .footer-section-content {
            max-height: 0;
            overflow: hidden;
            transition: max-height 0.3s ease;
          }

          .footer-section-content.expanded {
            max-height: 500px;
            padding-top: 15px;
          }

          .footer-section-content ul {
            margin-bottom: 0;
          }

          .footer-section-content li {
            padding: 8px 0;
            border-bottom: 1px solid rgba(255, 255, 255, 0.05);
          }

          .footer-section-content li:last-child {
            border-bottom: none;
          }

          .footer-section-content a:hover {
            color: #fff !important;
            padding-left: 5px;
            transition: all 0.3s ease;
          }

          /* Adjust spacing for mobile */
          .col-md-6 {
            margin-bottom: 20px;
          }

          .subscribe-container {
            margin-bottom: 20px;
          }

          .subscribe {
            height: 48px !important;
          }

          .subscribe button {
            height: 38px !important;
            width: 38px !important;
          }

          /* Social media icons spacing */
          .d-flex.gap-3 {
            gap: 15px !important;
          }

          .d-flex.gap-3 a {
            padding: 8px;
            background-color: rgba(255, 255, 255, 0.1);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.3s ease;
          }

          .d-flex.gap-3 a:hover {
            background-color: rgba(255, 255, 255, 0.2);
            transform: scale(1.1);
          }
        }

        /* Small mobile devices */
        @media (max-width: 575.98px) {
          .footer-section-header h5 {
            font-size: 16px;
            margin-bottom: 0 !important;
          }

          .footer-section-content {
            font-size: 13px;
          }

          .subscribe {
            height: 44px !important;
          }

          .subscribe button {
            height: 34px !important;
            width: 34px !important;
          }

          .subscribe input {
            font-size: 14px;
          }
        }

        /* Extra small devices */
        @media (max-width: 375px) {
          .footer-section-header h5 {
            font-size: 15px;
          }

          .footer-section-content {
            font-size: 12px;
          }

          .subscribe {
            height: 40px !important;
          }

          .subscribe button {
            height: 30px !important;
            width: 30px !important;
          }
        }

        /* Desktop styles remain unchanged */
        @media (min-width: 768px) {
          .footer-section-header {
            cursor: default;
          }

          .mobile-toggle {
            display: none !important;
          }

          .footer-section-content {
            max-height: none !important;
            overflow: visible !important;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;
